import styled from 'styled-components';

import * as colors from '../../common/styles/colors';
import { respondTo } from '../../common/styles/mixins';

export const MaintenanceWrapper = styled.div`
  height: 100vh;
  display: flex;
  font-size: 1.1rem;

  .hammer-icon {
    text-align: center;
  }

  .wrapper {
    height: auto !important;
    ${respondTo.tablet`
  		height: 100% !important;
	`};
  }

  ${respondTo.tablet`
    .padded-wrapper.logo-wrapper {
	    text-align: center;
	    padding: 5em;
    }

	  .padded-wrapper.form-wrapper {
      padding: 3em;
	    max-width: 600px;
    }
  `};

  .drax-logo {
    width: 140px;
    padding-bottom: 50px;

    ${respondTo.tablet`
		  width: 100%;
    	max-width: 600px;
		  padding-bottom: 0;
  	`};
  }

  h1 {
    text-align: center;
    padding: 40px;
    color: ${colors.hydroBlue};
  }

  p {
    max-width: 450px;
    text-align: center;
  }

  a {
    color: ${colors.hydroBlue};
    text-decoration: underline;
  }
`;
